<!-- 客户邮件 -->
<template>
  <div class="content">
    <div class="filter">
      <el-button type="primary" @click="$refs.emailDialog.open()">新增</el-button>
       <el-select v-model="listForm.type" placeholder="邮件类型" @change="initPage" style="width:120px" clearable>
          <el-option label="全局邮件" :value="1"></el-option>
          <el-option label="固定邮件" :value="2"></el-option>
        </el-select>
      <el-select v-model="listForm.status" placeholder="状态" @change="initPage" style="width:120px" clearable>
          <el-option label="开启" :value="1"></el-option>
          <el-option label="关闭" :value="0"></el-option>
        </el-select>
      <el-input placeholder="请输入关键字" v-model="listForm.searchContent" class="input-with-select" @blur="search"  @keyup.enter.native="search" clearable @clear="handleClear">
        <el-select v-model="listForm.searchType" slot="prepend" placeholder="请选择" @change="handleChange" style="width:120px" >
          <el-option label="标题" :value="1"></el-option>
          <el-option label="创建人" :value="2"></el-option>
          <el-option label="更新人" :value="3"></el-option>
        </el-select>
      </el-input>
    </div>

    <el-table :data="emailList" height="calc(100vh - 198px)" >
     <el-table-column label="序号" width="150" :show-overflow-tooltip="true">
       <template slot-scope="{$index}">
         <span>{{ $index+1 }}</span>
       </template>
     </el-table-column>
      <el-table-column prop="title" label="标题" min-width="150" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="type" label="邮件类型"  min-width="150">
        <template slot-scope="{row}">
          <span>{{row.type===1?'全局邮件':'固定邮件'}}</span>
        </template>
      </el-table-column>
      <el-table-column label="触发条件"  min-width="150">
        <template slot-scope="{row}">
          <span v-if="row.triggerType===1">触发类型:{{ getEventName(row.triggerCondition.eventType) }}</span>
          <span v-if="row.triggerType===2">触发条件:{{row.triggerCondition.cycleType ===1?'每天一次':'执行一次'}}</span><br>
          <span v-if="row.triggerType===2">执行时间:{{row.triggerCondition.value}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="status" label="状态" min-width="120">
        <template slot-scope="{row}">
          <span>{{row.status===1?'开启':'关闭'}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="createDate" label="人员信息" min-width="160">
        <template slot-scope="{row}">
          <span>创建人:{{row.creater}}</span><br>
          <span>最后修改人:{{row.modifier}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="confUpdateTime" label="时间信息" min-width="160">
        <template slot-scope="{row}">
          <span>创建时间:{{getDateFormat(row.createDate)}}</span><br>
          <span>更新时间:{{getDateFormat(row.confUpdateTime)}}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="180">
        <template slot-scope="{row}">
          <el-button type="text" size="medium" @click="$refs.emailDialog.open(row.id)">编辑</el-button>
          <el-button type="text" size="medium" @click="deleteEmail(row.id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="f-b-c bg-white" style="padding: 10px">
      <div></div>
      <el-pagination background :current-page="listForm.pageNumber" :page-sizes="[20, 50, 100, 200, 500]" :page-size="listForm.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total" class="el-pagination" @size-change="sizeChange" @current-change="pageChange" />
    </div>
    <email-dialog ref="emailDialog" @submitEmail="getEmailTaskList" @preview="previewContent" :eventList="eventList"></email-dialog>
    <el-dialog :visible="previewVisible" @close="previewVisible = false">
      <div id="previewContentBox"></div>
    </el-dialog>
  </div>
</template>

<script>
import API from '@/api'
import { dateFormat } from '@/utils/date'
import EmailDialog from './components/EmailDialog'
export default {
  name: 'operation_email',
  components:{EmailDialog},
  data() {
    return {
      registerDate: [],
      tabName: 'first',
      input: '',
      total: 0,
      managerTotal: 0,
      filterType: '1',
      listForm: {
        pageNumber: 1,
        pageSize: 20,
        searchContent:''
      },
      userManager: [],//对接人
      currentFilter: '',
      emailList: [],//邮件列表
      previewVisible: false,
      eventList: []
    }
  },
  created() {
    this.getEmailTaskList()
    this.messageEmailEvents()
  },
  computed: {
    getEventType() {
      return (type) => {
        switch (type) {
          case 1:
            return '用户注册时'
          case 2:
            return '首次绑定时'
          case 4:
            return '用户出单后'
          case 5:
            return '标记发货后'
          case 6:
            return '定制需求创建后'
          case 7:
            return '订单付款后'
          case 8:
            return 'kaka产品下架后'
          case 9:
            return '加购未下单'
          case undefined:
            return '-'
        }
      }
    },
  },
  methods: {
    getEmailTaskList(){
      API.getEmailTaskList(this.listForm).then(res=>{
        this.emailList=res.data.list
        this.total=res.data.total
        this.emailList.forEach(item=>{
          item.triggerCondition=JSON.parse( item.triggerCondition)
        })
        this.$tableScrollTop()
      })
    },

    deleteEmail(id){
      this.$confirm('是否删除该邮件','提示',{
        confirmButtonText:'确定',
        cancelButtonText:'取消',
        type:'warning'
      }).then(()=>{
        API.deleteEmailTask(id).then(res=>{
          if(res.code===10000){
            this.getEmailTaskList()
          }else{
            this.$message.error(res.message)
          }
        })
      })
    },

    getDateFormat(date){
      return dateFormat(date)
    },

    //切换筛选条件
    handleChange() {
      this.listForm.searchContent = ''
    },

    initPage() {
        this.listForm.pageNumber = 1
      this.getEmailTaskList()
    },
    search(value) {
        if(value!==''){
          this.listForm.pageNumber = 1
      this.getEmailTaskList()
        }
    },

    handleClear(){
      this.listForm.searchContent=''
      this.getEmailTaskList()
    },
    sizeChange(size) {
      this.listForm.pageSize = size
      this.getEmailTaskList()
    },
    pageChange(page) {
      this.listForm.pageNumber = page
      this.getEmailTaskList()
    },
    previewContent(data) {
      this.previewVisible = true
      this.$nextTick(()=>{
        const ele = document.getElementById('previewContentBox')
        ele.innerHTML = data
      })
    },
    messageEmailEvents() {
      API.messageEmailEvents().then(res=>{
        this.eventList = res.data.data
        console.log(this.eventList)
      })
    },
    getEventName(type) {
      return this.eventList.find(e=>e.eventType === type).eventName
    }
  }
}
</script>

<style lang="scss" scoped>
.content {
  height: 100%;
  background: #ffffff;
  padding: 12px 12px 0;
  .filter {
    padding: 12px;
    & > div {
      margin-left: 12px;
    }
    /deep/.el-input-group {
      width: 300px;
    }
    /deep/.el-input-group__prepend {
      width: 100px;
    }
  }
}
</style>>
